/* BBK options remain authoritative for hardware, availability, prices and cart. */
(()=>{'use strict';
const studio=document.querySelector('[data-ceika-bbk-studio]');
const section=studio?.closest('.ceika-product-pilot'),config=section?.querySelector('ceika-native-configurator');
if(!studio||!config)return;
const map=JSON.parse(studio.querySelector('[data-bbk-studio-map]').textContent);
const note=studio.querySelector('[data-bbk-studio-status]'),axleSelect=studio.querySelector('[data-bbk-studio-axle]');
const previewWheelSizes=[18,19,20,21,22,23,24];
const engine=()=>config.extrasController?.engine;
const previewDefaults={axle:'front',model:'BC1607-F',rotorKey:'330x32',finish:'gloss-painted-color-with-anti-corrosion-pre-coat',color:'gloss-painted-red',logoColor:'gloss-painted-black',floating:true};
function previewSetup(wheel,reason){
 const diameter=Number(wheel)||19,brake={...previewDefaults},brakeOnly=!previewWheelSizes.includes(diameter);
 return {version:1,panel:'brake',brake,previewWheelDiameter:diameter,brakeOnly,previewDefault:true,previewReason:reason,params:{panel:'brake',axle:brake.axle,model:brake.model,rotorKey:brake.rotorKey,finish:brake.finish,color:brake.color,logo:brake.logoColor,rotorFloating:'1',wheelOn:brakeOnly?'0':'1',vehicleOn:'0',...(!brakeOnly?{diameter:String(diameter)}:{})},...(!brakeOnly?{wheel:{diameter}}:{})};
}
function setup(){
 const e=engine(),wheel=Number(config.dataset.wheel);
 if(!e)return previewSetup(wheel,'Complete your BBK selections to replace this default preview with your exact setup.');
 const hardware=e.hardwareState?.hardware||{},axles=Object.keys(hardware).filter(a=>['front','rear'].includes(a));
 if(!axles.length)return previewSetup(wheel,'Choose a caliper size to replace this default preview with your exact setup.');
 let axle=axleSelect.value;if(!axles.includes(axle))axle=axles[0];axleSelect.value=axle;
 for(const option of axleSelect.options)option.disabled=!axles.includes(option.value);
 axleSelect.closest('label').hidden=axles.length<2;
 const h=hardware[axle],reference=String(h.reference||'');
 const model=Object.keys(map.models).sort((a,b)=>b.length-a.length).find(id=>reference===id||reference.startsWith(id+'-'));
 if(!model)return {unavailable:'This selected caliper does not have a 3D model.'};
 const rotorKey=Number(h.diameter)+'x'+Number(h.thickness);
 if(!map.models[model].includes(rotorKey))return {unavailable:'This selected rotor and caliper combination is unavailable in 3D.'};
 const suffix=e.variant?.mode==='Front + Rear'?'both':'single';
 const finishKey=e.selected['finish-'+suffix]||'',selectedFinish=map.finishes.find(f=>f.key===finishKey||f.key+'-front-rear'===finishKey);
 if(selectedFinish?.key.startsWith('custom-'))return {unavailable:'Your custom paint cannot be reproduced in this 3D preview.'};
 const finish=!selectedFinish||selectedFinish.key.startsWith('custom-')?map.finishes.find(f=>f.key===previewDefaults.finish):selectedFinish;
 const chosenColor=e.selected[finish.colorOptionKey],color=finish.colors.includes(chosenColor)?chosenColor:(finish.colors.includes(previewDefaults.color)?previewDefaults.color:finish.colors[0]);
 const chosenLogo=e.selected['logo-color'],logoColor=map.logos.includes(chosenLogo)?chosenLogo:previewDefaults.logoColor;
 const floating=e.selected['floating-'+axle]||e.selected['floating-'+suffix]||'';
 const isFloating=floating.startsWith('full-floating')&&(suffix!=='both'||!floating.endsWith('-only')||floating.includes('-'+axle+'-only'));
 const brake={axle,model,rotorKey,finish:finish.key,color,logoColor,floating:isFloating};
 if(e.selected.surface)brake.surface=e.selected.surface;
 if(e.selected['hat-color'])brake.hatColor=e.selected['hat-color'];
 const previewWheel=wheel>0?wheel:19,brakeOnly=!previewWheelSizes.includes(previewWheel);
 const previewDefault=!selectedFinish||selectedFinish.key.startsWith('custom-')||color!==chosenColor||logoColor!==chosenLogo;
 return {version:1,panel:'brake',brake,previewWheelDiameter:previewWheel,brakeOnly,previewDefault,previewReason:previewDefault?'Default finish colours are shown until your caliper and logo colours are selected.':'',params:{panel:'brake',axle,model,rotorKey,finish:finish.key,color,logo:logoColor,rotorFloating:isFloating?'1':'0',wheelOn:brakeOnly?'0':'1',vehicleOn:'0',...(!brakeOnly?{diameter:String(previewWheel)}:{})},...(!brakeOnly?{wheel:{diameter:previewWheel}}:{})};
}

function capture(){
  const value=setup(),e=engine();
  if(value.unavailable){studio.ceikaStudioSetup=value;return value;}
  value.standalone=true;
  value.params.wheelOn='0';
  value.params.wheel='SS-1';
  if(value.brake.surface)value.params.rotorSurface=value.brake.surface;
  if(value.brake.hatColor)value.params.hatColor=value.brake.hatColor;
  value.params.clearcoat=e?.finishState?.().coated?'1':'0';
  value.native={variant:config.querySelector('[data-pilot-variant]')?.value||e?.variant?.id||'',
    mode:e?.variant?.mode||'',parking:!!e?.parkingIncluded,selected:{...e?.selected},kits:e?.hardwareState?.hardware||{},
    vehicle:e?.text?.vehicle||'',dustManual:config._dustIntent?.manual===true};
  studio.ceikaStudioSetup=value;
  return value;
}
function refresh(){try{const value=capture();note.textContent=value.unavailable||value.previewReason||'';}catch{
  studio.ceikaStudioSetup=null;note.textContent='Select your brake kit to open the Studio.';}}
studio.querySelector('[data-studio-launch]').addEventListener('click',refresh,true);
axleSelect.addEventListener('change',refresh);
config.addEventListener('ceika:total',refresh);
config.addEventListener('change',()=>queueMicrotask(refresh));
function choose(e,key,value){const o=e.options.get(key);if(!o||!e.visible(key)||!o.values.some(v=>v.key===value&&e.valueAllowed(o,v)))return false;e.choose(key,value);return true;}

studio.addEventListener('ceika:standalone-finish',event=>{
  const e=engine(),state=event.detail;if(!e||!state)return;
  const suffix=e.variant.mode==='Front + Rear'?'both':'single',f=map.finishes.find(f=>f.key===state.finish);
  if(f&&!f.key.startsWith('custom-')){
    const option=e.options.get('finish-'+suffix),match=option?.values.find(v=>v.key===f.key||v.key===f.key+'-front-rear');
    if(match&&choose(e,option.key,match.key))choose(e,f.colorOptionKey,state.color);
  }
  choose(e,'clearcoat-'+suffix,state.clearcoat?'gloss-clear-coat':'without-clear-coat');
  choose(e,'logo-color',state.logoColor);config.extrasController.update();refresh();
});
// Native restoration is scoped to the exact store and product that issued the return link.
const returnKey=location.hash.match(/^#ceika-studio-return=([0-9a-f-]{36})$/i)?.[1];
if(returnKey){
 let restored=false;
 function restore(){
  if(restored||!config.restoreKit||!engine()||!config.extrasController?.restore)return;
  restored=true;
  try{
   const ctx=JSON.parse(localStorage.getItem('ceika.studio.v2.launch.'+returnKey)||'null');
   const dest=new URL(ctx.productURL);
   if(ctx.key!==returnKey||ctx.store!==studio.dataset.studioStore||ctx.product!==studio.dataset.productId||dest.origin!==location.origin||dest.pathname!==location.pathname||Date.now()-ctx.at>86400000)throw Error();
   const value=ctx.setup,n=value.native,e=engine();
   if(n.variant){const saved={variantId:n.variant,wheel:value.previewWheelDiameter,parking:n.parking,selected:n.selected,
     dustIntent:{manual:n.dustManual},text:{...e.text,vehicle:n.vehicle},uploads:{...e.uploads}};
    config.restoreKit(saved);config.extrasController.restore(saved);axleSelect.value=value.brake.axle;}
   history.replaceState(history.state,'',dest.href);refresh();
  }catch{note.textContent='Choose your brake kit options to reopen this saved preview.';}
 }
 config.addEventListener('ceika:total',restore);queueMicrotask(restore);
}
refresh();
})();
